export enum ViewSourceType {
    REPORT = 'REPORT',
    SHEET = 'SHEET',
}
